import { domainToDisplayName } from "@utils/domainUtils"

// Month + year, e.g. "Oct 2025" — enough to tell cohorts apart without noise.
export function formatProgramStartDate(startDate: string): string {
  const date = new Date(startDate)
  if (isNaN(date.getTime())) {
    return ""
  }
  return date.toLocaleDateString(undefined, {
    month: "short",
    year: "numeric",
  })
}

function programTypeLabel(type?: string): string | undefined {
  if (type === "full_time") {
    return "Full-time"
  }
  if (type === "part_time") {
    return "Part-time"
  }
  return undefined
}

// The PROGRAM name for a student's enrollment chip: the program's real name +
// cohort, e.g. "IHK Data Analytics · Jul 2026" — the SAME name the add-program
// picker shows (the campus program title / track name), NOT the school/domain,
// which repeated ("Data Analysis") across every program in a school (Mayer). It
// drops the offering specifics — track and language — that made the chip read
// as an offering; those live in the tooltip via formatProgramLabel. `name` is
// the campus program title; it falls back to the school name only when a caller
// has no title (older payloads).
export function formatProgramName(program: {
  name?: string | null
  domain: string
  startDate: string
}): string {
  return [
    program.name?.trim() || domainToDisplayName(program.domain),
    formatProgramStartDate(program.startDate),
  ]
    .filter(Boolean)
    .join(" · ")
}

// The full OFFERING descriptor — program, cohort, track and language — used by
// the add picker (where distinguishing offerings matters) and as the chip
// tooltip. e.g. "Software · Oct 2025 · Full-time · English".
export function formatProgramLabel(program: {
  domain: string
  startDate: string
  type?: string
  language?: string
}): string {
  return [
    domainToDisplayName(program.domain),
    formatProgramStartDate(program.startDate),
    programTypeLabel(program.type),
    program.language,
  ]
    .filter(Boolean)
    .join(" · ")
}
